module.exports = __webpack_public_path__ + "assets/visage-09c1d8951ba0c90bb65445223c53b9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/visage.jpg
// module id = 527
// module chunks = 1